module.exports = __webpack_public_path__ + "static/media/carouselVid.c42bb28e.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/carouselVid.mov
// module id = 405
// module chunks = 0